module.exports = __webpack_public_path__ + "img/gallery-image-16.706df43b.jpg";